var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entrepreneur-thumbnail"},[_c('div',{staticClass:"entrepreneur-thumbnail__inner"},[_c('card-thumbnail',{attrs:{"image":_vm.img,"bg":_vm.bg}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }